"use client";

import { PATHS } from "@/consts";
import CartSummary from "@/features/cart/components/CartSummary/CartSummary";
import { useRichText } from "@/hooks/useRichText";
import { useTranslations } from "@/i18n/client";
import { Link } from "@/i18n/routing";
import { useCart } from "@/lib/centra/hooks";
import { useRemovedProduct } from "../../cartStore";
import { CartItemToast } from "../CartItem/CartItemToast";
import CartItems from "../CartItems/CartItems";
import CartUpsell from "../CartUpsell/CartUpsell";
import EmptyCart from "./EmptyCart";
import styles from "./index.module.css";

const CartContent = () => {
  const { data: cart } = useCart();
  const { rich } = useRichText();
  const t = useTranslations();
  const removedItem = useRemovedProduct((state) => state.item);

  return (
    <div className={styles.cartContent}>
      {cart?.items?.length ? (
        <CartItems />
      ) : (
        <div>
          {removedItem && <CartItemToast item={removedItem} />}
          {!removedItem && (
            <EmptyCart
              text={t("modal.emptycart")}
              linkText={rich(t("modal.exploreCollections"), {
                link: (chunks) => (
                  <Link key={1} href={PATHS.products}>
                    {chunks}
                  </Link>
                ),
              })}
            />
          )}
        </div>
      )}
      <CartUpsell />
      <CartSummary />
    </div>
  );
};

export default CartContent;
